import { COPY_CHARACTER_CUSTOM_TYPE } from "stores/modules/entities.room.characters/operations";
import { decodeBase64ToUnicode } from "./base64";
import i18next from "i18next";

export const readDataFromClipboard = async () => {
  try {
    const clipboardItem = await navigator.clipboard.read();
    const firstItem = clipboardItem[0];
    if (firstItem && firstItem.types.includes(COPY_CHARACTER_CUSTOM_TYPE)) {
      const blob = await firstItem.getType(COPY_CHARACTER_CUSTOM_TYPE);
      const text = await blob.text();
      const parse = new DOMParser();
      const html = parse.parseFromString(text, COPY_CHARACTER_CUSTOM_TYPE);
      const span = html.querySelector("span");
      if (span) {
        const metadata = span.dataset.metadata;
        if (metadata) {
          return decodeBase64ToUnicode(metadata);
        }
      }
    }

    if (firstItem?.types.includes("text/plain")) {
      const blob = await firstItem.getType("text/plain");
      return await blob.text();
    }
    return null;
  } catch (e) {
    console.error(e);
    window.alert(
      i18next.t(
        "クリップボードからの読み込みに失敗しました\n再度お試しいただくか、ブラウザの設定をご確認ください"
      )
    );
    return null;
  }
};
